// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TextWordBreakWrapper-module-defaultWrapText-1Bghz{word-break:break-word}.TextWordBreakWrapper-module-asianWrapText-27zEh{word-break:keep-all}", ""]);
// Exports
exports.locals = {
	"defaultWrapText": "TextWordBreakWrapper-module-defaultWrapText-1Bghz",
	"asianWrapText": "TextWordBreakWrapper-module-asianWrapText-27zEh"
};
module.exports = exports;
